import { render, staticRenderFns } from "./ProyectosTecnico.vue?vue&type=template&id=1d5dc9c0&scoped=true"
import script from "./ProyectosTecnico.vue?vue&type=script&lang=js"
export * from "./ProyectosTecnico.vue?vue&type=script&lang=js"
import style0 from "./ProyectosTecnico.vue?vue&type=style&index=0&id=1d5dc9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dc9c0",
  null
  
)

export default component.exports